import { useIntl } from 'react-intl';

import { Box } from '~/eds/src/components/Box/Box';
import { Chip } from '~/eds/src/components/Chip/Chip';
import { IconButton } from '~/eds/src/components/IconButton/IconButton';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { Text } from '~/eds/src/components/Text/Text';
import { StatusType } from '~/eds/src/types/StatusType';
import {
  GuidelineClauseVariation,
  PositionType,
} from '~/redux/api/types/playbooks/guidelines';
import HtmlContent from '~/ui/components/HtmlContent/HtmlContent';

type Props = {
  variation: GuidelineClauseVariation;
  onDelete?: () => void;
};

export const Variation = ({ variation, onDelete }: Props) => {
  const intl = useIntl();
  const chipStatus: Record<PositionType, StatusType> = {
    Preferred: 'success',
    Fallback: 'warning',
    'Walk away': 'danger',
  };

  const positionLabels: Record<PositionType, string> = {
    Preferred: intl.formatMessage({
      id: 'guidelines.variation.position.preferred',
      defaultMessage: 'Preferred',
      description: 'Label for preferred variation position',
    }),
    Fallback: intl.formatMessage({
      id: 'guidelines.variation.position.fallback',
      defaultMessage: 'Fallback',
      description: 'Label for fallback variation position',
    }),
    'Walk away': intl.formatMessage({
      id: 'guidelines.variation.position.walkAway',
      defaultMessage: 'Walk Away',
      description: 'Label for walk away variation position',
    }),
  };

  return (
    <Layout
      border="border"
      flex="1"
      borderRadius="m"
      p={3}
      direction="column"
      spacing={3}
    >
      <Layout align="center" spacing={2}>
        <Chip
          mode="tag"
          status={chipStatus[variation.position]}
          text={positionLabels[variation.position]}
        />
        <Text variant="body-medium">{variation.name}</Text>
      </Layout>
      <Box bg="background.info" px={3} borderRadius={4}>
        <HtmlContent
          html={variation.text ?? ''}
          style={{
            wordBreak: 'break-word',
            overflowWrap: 'anywhere',
            maxWidth: '100%',
            width: '100%',
            fontSize: '14px',
          }}
        />
      </Box>
      <Box pl={3}>
        <HtmlContent
          html={variation.guidance ?? ''}
          style={{
            wordBreak: 'break-word',
            overflowWrap: 'anywhere',
            maxWidth: '100%',
            width: '100%',
            fontSize: '14px',
          }}
        />
      </Box>
      {onDelete && (
        <Layout justify="flex-end">
          <IconButton icon="trash" onClick={onDelete} />
        </Layout>
      )}
    </Layout>
  );
};
